var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.modifiedItems),function(student,index){return _c('battle-rating-preview',{key:index,attrs:{"student":student,"battle-rating":student.battleRating}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }